/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ViewAdminWrapper } from "../../components/ManageAdmin/style";
import MaterialInput from "../../components/common/UI/MaterialInput";
import {
  Heading,
  TableWarpper,
  Text,
} from "../../components/styledConstants";
import { getParams, fromDateConvert, toDateConvert, dateConvertWithoutTime } from "../../utils/common";
import Request from "../../utils/Request";
import Config from "../../utils/config";
import CsvDown from "../../components/ExportFiles/CsvDown";
import PdfDown from "../../components/ExportFiles/PdfDown";
import FilterBox from "../../components/common/FilterBox";
import Pagination from "../../components/common/Pagination";
import Loader from "../../components/common/Loader";
import TableLoader from "../../components/common/TableLoader";
import ErrorMessage from "../../components/ErrorMessage";
import SuccessMessage from "../../components/SuccessMessage";
import IconDate from "../../assets/images/IconDate";
import { FilterWrapper } from "../Merchants/style";
import ItemPerPage from "../../components/common/ItemPerPage";

const statusOptions = [
//   { value: "", label: "All Status" },
  { value: "SUCCESS", label: "Success" },
  { value: "FAILED", label: "Failed" },
//   { value: "PENDING", label: "Pending" },
//   { value: "INITIATED", label: "Initiated" },
];


const filterForm = [
 
  {
    name: "rrn",
    type: "text",
    placeholder: "RRN",
    value: "",
  },
  {
    name: "cardRefNo",
    type: "text",
    placeholder: "Card Reference No.",
    value: "",
  },
  {
    icon: <IconDate />,
    name: "fromDate",
    value: "",
    className: "item-text pl16",
    dateFormat: "d-MM-yyyy",
    type: "date",
    showMonthDropdown: true,
    showYearDropdown: true,
    yearDropdownItemNumber: 10,
    scrollableYearDropdown: true,
    placeholder: "From Date",
    maxDate: new Date(),
    error: "",
  },
  {
    icon: <IconDate />,
    name: "toDate",
    value: "",
    className: "item-text pl16",
    dateFormat: "d-MM-yyyy",
    type: "date",
    showMonthDropdown: true,
    showYearDropdown: true,
    yearDropdownItemNumber: 10,
    scrollableYearDropdown: true,
    placeholder: "To Date",
    maxDate: new Date(),
    error: "",
  },
  {
    name: "txnStatus",
    value: "",
    type: "select",
    placeholder: "Transaction Status",
    options: statusOptions,
  },
 
];

export default function OfflineTransactionReport() {
  const [controls, setControls] = useState([...filterForm]);
  const [txnData, setTxnData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [loader, setLoader] = useState(false);
  const [downloadPayload, setDownloadPayload] = useState({});
  const [message, setMessage] = useState({ success: "", error: "" });
  const [appliedFilters, setAppliedFilters] = useState([...filterForm]);

  const navigate = useNavigate();
  const location = useLocation();

  const fetchOfflineTransactions = () => {
    setLoader(true);

   const successHandler = (res) => {

    setLoader(false);
  
    if (res?.metaInfo?.data) {
      setTxnData(res.metaInfo.data);
      setTotalPages(res.metaInfo.totalPages || 1);
    } else {
      setTxnData([]);
      setTotalPages(1);
    }
  
    const params = getParams(appliedFilters);
  
    params.pagination = {
      pageNo: currentPage,
      pageSize: pageSize,
    };
     
    if (params?.txnStatus?.value) {
       params.txnStatus = params.txnStatus.value;
     }

    // Date formatting
    if (params.fromDate) {
      params.fromDate = dateConvertWithoutTime(
        fromDateConvert(params.fromDate)
      );
    }
  
    if (params.toDate) {
      params.toDate = dateConvertWithoutTime(
        toDateConvert(params.toDate)
      );
    }
  
    setDownloadPayload(params);
 };

    const errorHandler = (err) => {
      setLoader(false);
      setMessage({ error: "Failed to fetch transactions" });
    };

    const api = new Request("", successHandler, errorHandler, false);
    const params = getParams(controls);

    params.pagination = {
      pageNo: currentPage,
      pageSize: pageSize,
    };
     if (params?.txnStatus?.value) {
       params.txnStatus = params.txnStatus.value;
     }

    // Date formatting for API call
    if (params.fromDate) {
      params.fromDate = dateConvertWithoutTime(fromDateConvert(params.fromDate));
    }
    if (params.toDate) {
      params.toDate = dateConvertWithoutTime(toDateConvert(params.toDate));
    }

    console.log("Offline Txn Params:", params);

    return api.post(
      Config.apis.admin.OFFLINE_TRANSACTION_REPORT, 
      params
    );
  };

useEffect(() => {
  fetchOfflineTransactions();
}, [appliedFilters, currentPage, pageSize]);

 const FilterChangeHandler = (event, index) => {
  const _controls = [...controls];

  if (_controls[index].type === "select") {
    // Store full selected object
    _controls[index].value = event;
  } else {
    _controls[index].value =
      event?.target?.value ?? event;
  }

  if (_controls[index].name === "fromDate") {
    _controls[3].minDate = new Date(_controls[index].value);
    _controls[3].value = "";
  }

  setControls(_controls);
};
const searchTransactions = (e) => {
  e.preventDefault();
  setCurrentPage(1);
  setAppliedFilters([...controls]);
};
 const resetFilter = () => {
  const resetControls = filterForm.map((item) => ({
    ...item,
    value: "",
    error: "",
  }));

  setControls(resetControls);
  setAppliedFilters(resetControls);
  setCurrentPage(1);
};

  // CSV Headers
  const csvHeaders = [
    { label: "Transaction ID", key: "txnId" },
    { label: "Corp ID", key: "corpId" },
    { label: "RRN", key: "rrn" },
    { label: "Amount", key: "amount" },
    { label: "Transaction Type", key: "txnType" },
    { label: "Status", key: "txnStatus" },
    { label: "Created At", key: "createdAt" },
    { label: "Card Number", key: "maskedCardNo" },
  ];

  // PDF Table Header (display columns)
  const tableHeader = [
    {
      txnId: "Txn ID",
      corpId: "Corp ID",
      rrn: "RRN",
      amount: "Amount",
      txnType: "Type",
      txnStatus: "Status",
      createdAt: "Date & Time",
    },
  ];

  const getTableBody = (data) => {
    return data.map((item) => ({
      txnId: item.txnId || "-",
      corpId: item.corpId || "-",
      rrn: item.rrn || "-",
      amount: `₹ ${parseFloat(item.amount || 0).toFixed(2)}`,
      txnType: item.txnType || "-",
      txnStatus: item.txnStatus || "-",
      createdAt: item.createdAt ? item.createdAt.replace("T", " ") : "-",
    }));
  };

  return (
    <>
      <div className="flex flex-center space-between mb10">
        <Heading size="xxl" color="color7">
          Offline Transactions
        </Heading>

        <div className="flex flex-center">
          <div className="mr20">
            <CsvDown
              headers={csvHeaders}
              url={`${Config.apis.admin.OFFLINE_TRANSACTION_REPORT}`}
              params={downloadPayload}
              title="CSV"
            />
          </div>
          <div>
            <PdfDown
              heading="Offline Transactions"
              tableHeader={tableHeader}
              getTableBody={getTableBody}
              url={`${Config.apis.admin.OFFLINE_TRANSACTION_REPORT}`}
              params={downloadPayload}
            />
          </div>
        </div>
      </div>

      <ViewAdminWrapper>
        <FilterWrapper>
          <FilterBox
            filterForm={controls}
            onFilterChange={FilterChangeHandler}
            onFilterSubmit={searchTransactions}
            refreshPage={resetFilter}
            className="transactionfilter"
          />
        </FilterWrapper>

        {message.error && <ErrorMessage error={message.error} />}
        {message.success && <SuccessMessage successMessage={message.success} />}

        <TableWarpper className="mt24">
          <table className="table">
            <thead>
             <tr>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">TID</Text></th>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">Corp ID</Text></th>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">RRN</Text></th>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">Amount</Text></th>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">MCC</Text></th>
                 <th className="text-left"><Text size="rg" color="color7" fw="medium">Narration</Text></th>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">Transaction Type</Text></th>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">Status</Text></th>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">Date</Text></th>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">Time</Text></th>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">Card Refernce No.</Text></th>
                <th className="text-left"><Text size="rg" color="color7" fw="medium">Card Number</Text></th>
              </tr>
            </thead>
            <tbody>
              {loader ? (
                <TableLoader colSpan={8} />
              ) : txnData.length > 0 ? (
                txnData.map((txn, index) => (
                  <tr key={index}>
                    <td><Text size="xsm" color="#828282">{txn?.tid || "-"}</Text></td>
                    <td><Text size="xsm" color="#828282">{txn?.corpId || "-"}</Text></td>
                    <td><Text size="xsm" color="#828282">{txn?.rrn || "-"}</Text></td>
                    <td>
                      <Text size="xsm" color="#828282" fw="medium">
                        ₹ {parseFloat(txn?.txnAmt || 0).toFixed(2)}
                      </Text>
                    </td>
                    <td><Text size="xsm" color="#828282">{txn?.mcc || "-"}</Text></td>
                    <td><Text size="xsm" color="#828282">{txn?.narration || "-"}</Text></td>
                    <td><Text size="xsm" color="#828282">{txn?.txnType || "-"}</Text></td>
                    <td>
                      <Text
                        size="xsm"
                        fw="medium"
                        color={txn.txnStatus === "SUCCESS" ? "color10" : txn.txnStatus === "FAILED" ? "color4" : "color7"}
                      >
                        {txn?.txnStatus || "-"}
                      </Text>
                    </td>
                    <td>
                      <Text size="xsm" color="#828282">
                        {txn?.txnDate
                         
                        || "-"}
                      </Text>
                    </td>
                     <td>
                      <Text size="xsm" color="#828282">
                         {txn?.txnTime
                         
                        || "-"}
                        {/* {txn.createdAt
                          ? txn.createdAt.split("T")[0] + " " + txn.createdAt.split("T")[1]?.split(".")?.[0]
                          : "-"} */}
                      </Text>
                    </td>
                    <td><Text size="xsm" color="#828282">{txn?.cardRefNo || "-"}</Text></td>
                    <td><Text size="xsm" color="#828282">{txn?.cardNo || "-"}</Text></td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </TableWarpper>

        <div className="mt24 flex flex-center">
          {txnData.length > 0 && (
            <ItemPerPage
              pageSize={pageSize}
              getPageSize={(size) => setPageSize(size)}
            />
          )}
          {totalPages > 1 && (
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              getCurrentPageData={setCurrentPage}
            />
          )}
        </div>
      </ViewAdminWrapper>
    </>
  );
}